export function generatePathFromName(nameValue: string) {
  return nameValue
    .toLowerCase()
    .trim()
    .replace(/[^\w\s]/gi, '')
    .replace(/\s+/g, '-')
    .slice(0, 32)
}
